var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFirstAid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.46038 11.375H3.91422C3.32394 11.375 2.84375 10.8948 2.84375 10.3045V8.78922C2.84375 8.64703 2.72797 8.53125 2.58538 8.53125H1.07047C0.480188 8.53125 0 8.05106 0 7.46078V3.91422C0 3.32394 0.480188 2.84375 1.07047 2.84375H2.58538C2.72797 2.84375 2.84375 2.72797 2.84375 2.58578V1.07047C2.84375 0.480188 3.32394 0 3.91422 0H7.46038C8.05107 0 8.53126 0.480188 8.53126 1.07047V2.58578C8.53126 2.72797 8.64704 2.84375 8.78923 2.84375H10.3041C10.8948 2.84375 11.375 3.32394 11.375 3.91422V7.46078C11.375 8.05106 10.8948 8.53125 10.3041 8.53125H8.78923C8.64704 8.53125 8.53126 8.64703 8.53126 8.78922V10.3045C8.53126 10.8948 8.05107 11.375 7.46038 11.375Z",
    fill: "#757575"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFirstAid);
export default __webpack_public_path__ + "static/media/FirstAid.271a104b4feb0836b656be367177a6c5.svg";
export { ForwardRef as ReactComponent };